import { Injector, StaticProvider } from '@angular/core';
import { DatasourceServiceDef, ModelingTabs, provideDatasource } from '@y42/datasource';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { ImpexServiceDef, provideImpex } from '@y42/impex';
import { JobServiceDef, provideJob } from '@y42/job';
import { Y42FeatureType } from '@y42/json-schema';
import {
  UiModelingAclService,
  UiModelingDataTestService,
  UiModelingGitService,
  UiModelingJobSettingsValidationService,
  UiModelingQuery,
  UiModelingService,
  UiModelingStore,
  UiModelingTableJobQuery,
  UiModelingTableJobService,
  UiModelingTableJobStore,
  UiModelingTableQuery,
  UiModelingTableService,
  UiModelingTableStore,
} from '@y42/ui-model';
import { DataTestServiceDef, provideDataTest } from '../../data-test/provide-data-test';

const UiModellingFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.UiModel,
    GIT_FOLDER: Y42GitFolders.UiModel,
    FEATURE_ROUTE: Y42Routes.UiModeling,
    DETAIL_TABS: ModelingTabs,
    AbstractFeatureService: UiModelingService,
    AbstractFeatureQueryEntity: UiModelingQuery,
    AbstractFeatureEntityStore: UiModelingStore,
    AbstractFeatureGitService: UiModelingGitService,
    AbstractFeatureAclService: UiModelingAclService,
    AbstractFeatureChildQueryEntity: UiModelingTableQuery,
  };
};

const UiModellingDatasourceProviders: () => DatasourceServiceDef = () => {
  return {
    DatasourceService: UiModelingService,
    DatasourceStore: UiModelingStore,
    DatasourceQuery: UiModelingQuery,
    DatasourceTableService: UiModelingTableService,
    DatasourceTableStore: UiModelingTableStore,
    DatasourceTableQuery: UiModelingTableQuery,
    DatasourceTableJobStore: UiModelingTableJobStore,
    DatasourceTableJobQuery: UiModelingTableJobQuery,
    DatasourceGitService: UiModelingGitService,
    DatasourceJobSettingsValidationService: UiModelingJobSettingsValidationService,
  };
};

const UiModellingJobProviders: () => JobServiceDef = () => {
  return {
    JobService: UiModelingTableJobService,
    JobQuery: UiModelingTableJobQuery,
    JobStore: UiModelingTableJobStore,
    JOB_OVERVIEW_MODELS: (injector: Injector) => injector.get(UiModelingQuery).activeTables$,
    ACTIVE_JOB_OVERVIEW_MODEL: (injector: Injector) => injector.get(UiModelingTableQuery).active$,
  };
};

const UiModelingDataTestProviders: () => DataTestServiceDef = () => ({
  DataTestService: UiModelingDataTestService,
  DataTestParentQuery: UiModelingTableQuery,
});

const UiModelingImpexProviders: () => ImpexServiceDef = () => ({
  ImpexService: UiModelingService,
  ImpexChildService: UiModelingTableService,
  ImpexQuery: UiModelingQuery,
  ImpexChildQuery: UiModelingTableQuery,
});

export function UiModelingProviders(
  options: { feature: boolean; datasource: boolean; job: boolean; dataTest: boolean; impex: boolean } = {
    feature: true,
    datasource: true,
    job: true,
    dataTest: true,
    impex: true,
  },
): StaticProvider[] {
  return [
    options.feature ? provideFeature(UiModellingFeatureProviders()) : [],
    options.datasource ? provideDatasource(UiModellingDatasourceProviders()) : [],
    options.job ? provideJob(UiModellingJobProviders()) : [],
    options.dataTest ? provideDataTest(UiModelingDataTestProviders()) : [],
    options.impex ? provideImpex(UiModelingImpexProviders()) : [],
  ];
}
